import { Layout } from '@loadsmart/miranda-react'

import { AppointmentStatus } from 'core/appointments/ui/AppointmentStatus'
import { type Stop, getDelivery, getExtraStops, getPickup, isMultiStop } from 'core/domain/Stop'
import { ExtraStopInformation } from 'core/ui/components/stop/ExtraStopInformation'
import { TimelineItem } from 'core/ui/components/timeline/TimelineItem'

import { Information } from './Information'

export type MobileStopsTimelineProps = {
  stops: Array<Stop>
  titleFormatter: (stop: Stop) => string
  subTitleFormatter?: (stop: Stop) => string | undefined
}

export function MobileStopsTimeline({
  stops,
  titleFormatter,
  subTitleFormatter,
}: MobileStopsTimelineProps) {
  const pickup = getPickup(stops)
  const delivery = getDelivery(stops)
  const hasExtraStops = isMultiStop(stops)
  const extraStops = getExtraStops(stops)

  return (
    <Layout.Stack gap="none">
      <TimelineItem position="first">
        <Information
          locationInfo={titleFormatter(pickup)}
          dateInfo={subTitleFormatter?.(pickup)}
          facilityName={pickup.facilityName}
        />
        <AppointmentStatus appointment={pickup.appointment} />
      </TimelineItem>
      {hasExtraStops && (
        <TimelineItem position="middle" dotless>
          <ExtraStopInformation
            stops={extraStops}
            titleFormatter={titleFormatter}
            subTitleFormatter={subTitleFormatter}
          />
        </TimelineItem>
      )}
      <TimelineItem position="last">
        <Information
          locationInfo={titleFormatter(delivery)}
          dateInfo={subTitleFormatter?.(delivery)}
          facilityName={delivery.facilityName}
        />
        <AppointmentStatus appointment={delivery.appointment} />
      </TimelineItem>
    </Layout.Stack>
  )
}
